import { useState, useRef } from 'react'

// ── Recherche utilisateur destinataire ───────────────────────
export function UserSearch({ users, resolved, setResolved }) {
  const [query, setQuery]   = useState('')
  const [matches, setMatches] = useState([])

  const search = (q) => {
    setQuery(q)
    if (!q.trim()) { setMatches([]); return }
    setMatches(users.filter(u =>
      u.name.toLowerCase().includes(q.toLowerCase()) ||
      u.email.toLowerCase().includes(q.toLowerCase())
    ).slice(0, 6))
  }
  const pick  = (u) => { setResolved({ id:u.id, name:u.name, email:u.email }); setQuery(u.email); setMatches([]) }
  const clear = () => { setResolved(null); setQuery(''); setMatches([]) }

  return (
    <div style={{ gridColumn:'1/-1', background:'var(--gold-lt)', border:'1.5px solid var(--gold)', borderRadius:10, padding:'12px 14px' }}>
      <label style={{ fontSize:11, fontWeight:700, color:'var(--slate)', textTransform:'uppercase', letterSpacing:'0.06em', display:'block', marginBottom:6 }}>👤 Utilisateur destinataire</label>
      {resolved ? (
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:700, color:'var(--blue)', fontSize:14 }}>{resolved.name}</div>
            <div style={{ fontSize:12, color:'var(--slate)' }}>{resolved.email}</div>
          </div>
          <span style={{ fontSize:11, fontWeight:700, color:'var(--green-dk)', background:'var(--green-lt)', padding:'3px 10px', borderRadius:100 }}>✓ Lié</span>
          <button type="button" className="adm-ta-btn adm-ta-del" style={{ padding:'4px 8px' }} onClick={clear}>✕</button>
        </div>
      ) : (
        <div style={{ position:'relative' }}>
          <input className="adm-input" style={{ marginBottom:0 }} placeholder="Rechercher par nom ou email…" value={query} onChange={e => search(e.target.value)} />
          {matches.length > 0 && (
            <div style={{ position:'absolute', top:'100%', left:0, right:0, zIndex:60, background:'var(--white)', border:'1.5px solid var(--gold)', borderRadius:9, boxShadow:'0 8px 24px rgba(0,0,0,.13)', overflow:'hidden', marginTop:2 }}>
              {matches.map(u => (
                <div key={u.id} style={{ padding:'9px 14px', cursor:'pointer', borderBottom:'1px solid var(--border)' }}
                  onMouseEnter={e=>e.currentTarget.style.background='var(--bg)'} onMouseLeave={e=>e.currentTarget.style.background=''}
                  onClick={() => pick(u)}>
                  <div style={{ fontWeight:700, color:'var(--blue)', fontSize:13 }}>{u.name}</div>
                  <div style={{ fontSize:12, color:'var(--slate)' }}>{u.email}</div>
                </div>
              ))}
            </div>
          )}
          {query.trim() && matches.length === 0 && (
            <div style={{ marginTop:6, fontSize:12, color:'var(--slate)', display:'flex', alignItems:'center', gap:5 }}>
              <span style={{ color:'#ca8a04', fontWeight:700 }}>⚠</span> Aucun compte trouvé.
            </div>
          )}
        </div>
      )}
    </div>
  )
}

// ── Signature canvas ──────────────────────────────────────────
function SigCanvas({ label, onSign }) {
  const ref = useRef(null)
  const drawing = useRef(false)
  const [signed, setSigned] = useState(false)

  const pos = (e, c) => { const r=c.getBoundingClientRect(),s=e.touches?e.touches[0]:e; return{x:(s.clientX-r.left)*(c.width/r.width),y:(s.clientY-r.top)*(c.height/r.height)} }
  const start = (e) => { e.preventDefault();drawing.current=true;const c=ref.current;if(!c)return;const ctx=c.getContext('2d'),p=pos(e,c);ctx.beginPath();ctx.moveTo(p.x,p.y) }
  const draw  = (e) => { e.preventDefault();if(!drawing.current)return;const c=ref.current;if(!c)return;const ctx=c.getContext('2d'),p=pos(e,c);ctx.lineWidth=2;ctx.lineCap='round';ctx.strokeStyle='#1e3a8a';ctx.lineTo(p.x,p.y);ctx.stroke();setSigned(true) }
  const stop  = (e) => { e.preventDefault();if(!drawing.current)return;drawing.current=false;const c=ref.current;if(c)onSign(c.toDataURL('image/png')) }
  const clear = () => { const c=ref.current;if(!c)return;c.getContext('2d').clearRect(0,0,c.width,c.height);setSigned(false);onSign(null) }

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
      <label style={{ fontSize:11, fontWeight:700, color:'var(--slate)', textTransform:'uppercase', letterSpacing:'0.06em' }}>{label}</label>
      <div style={{ position:'relative', border:'1.5px solid var(--border)', borderRadius:8, background:'#f8faff', overflow:'hidden' }}>
        <canvas ref={ref} width={340} height={120} style={{ display:'block', width:'100%', height:120, cursor:'crosshair', touchAction:'none' }}
          onMouseDown={start} onMouseMove={draw} onMouseUp={stop} onMouseLeave={stop}
          onTouchStart={start} onTouchMove={draw} onTouchEnd={stop} />
        {!signed && <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', pointerEvents:'none', color:'var(--slate-lt)' }}><span style={{ fontSize:22 }}>✍️</span><span style={{ fontSize:11 }}>Signez ici</span></div>}
      </div>
      <button type="button" className="adm-btn adm-btn-ghost" style={{ fontSize:11, padding:'3px 10px', alignSelf:'flex-start' }} onClick={clear}>🧹 Effacer</button>
      {signed && <div style={{ fontSize:11, color:'var(--green-dk)', fontWeight:600 }}>✅ Signature enregistrée</div>}
    </div>
  )
}

// ── Upload image drag & drop ──────────────────────────────────
function ImgUpload({ label, hint, preview, onFile, circle }) {
  const ref = useRef(null)
  const [drag, setDrag] = useState(false)
  const read = (file) => { if(!file||!file.type.startsWith('image/'))return;const rd=new FileReader();rd.onload=e=>onFile(e.target.result);rd.readAsDataURL(file) }
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
      <label style={{ fontSize:11, fontWeight:700, color:'var(--slate)', textTransform:'uppercase', letterSpacing:'0.06em' }}>{label}</label>
      {hint && <p style={{ fontSize:12, color:'var(--slate)', margin:0 }}>{hint}</p>}
      <div style={{ border:`2px dashed ${drag?'var(--gold)':'var(--blue)'}`, borderRadius:10, padding:'18px 14px', textAlign:'center', cursor:'pointer', background:drag?'var(--gold-lt)':'var(--bg)', transition:'all .18s' }}
        onClick={()=>ref.current?.click()}
        onDragOver={e=>{e.preventDefault();setDrag(true)}} onDragLeave={()=>setDrag(false)}
        onDrop={e=>{e.preventDefault();setDrag(false);read(e.dataTransfer.files[0])}}>
        <input ref={ref} type="file" accept="image/*" style={{ display:'none' }} onChange={e=>read(e.target.files[0])} />
        <div style={{ fontSize:26, marginBottom:4 }}>📁</div>
        <div style={{ fontSize:13, fontWeight:600, color:'var(--blue)' }}>Cliquez ou glissez pour uploader</div>
        <div style={{ fontSize:11, color:'var(--slate-lt)', marginTop:2 }}>JPG, PNG — max 5 Mo</div>
      </div>
      {preview && (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:6 }}>
          <img src={preview} alt="preview" style={{ maxWidth:circle?100:200, maxHeight:100, borderRadius:circle?'50%':10, border:circle?'2px solid #a52a2a':'1px solid var(--border)', objectFit:'cover' }} />
          <button type="button" className="adm-btn adm-btn-ghost" style={{ fontSize:11, padding:'3px 10px' }} onClick={()=>onFile(null)}>Retirer</button>
        </div>
      )}
    </div>
  )
}

// ── Lignes vaccinations dynamiques ───────────────────────────
function VaccinRows({ rows, setRows }) {
  const upd = (i,k,v) => setRows(r=>r.map((x,j)=>j===i?{...x,[k]:v}:x))
  const del = (i) => { if(rows.length>1)setRows(r=>r.filter((_,j)=>j!==i)) }
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
      {rows.map((row,i)=>(
        <div key={i} style={{ display:'grid', gridTemplateColumns:'2fr 1.5fr 1.5fr 2fr auto', gap:'6px 8px', alignItems:'end', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:8, padding:'10px 12px' }}>
          <div><label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Type de vaccin</label><input className="adm-input" value={row.type||''} onChange={e=>upd(i,'type',e.target.value)} placeholder="Ex: Rage" /></div>
          <div><label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Date</label><input className="adm-input" type="date" value={row.date||''} onChange={e=>upd(i,'date',e.target.value)} /></div>
          <div><label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Rappel</label><input className="adm-input" type="date" value={row.rappel||''} onChange={e=>upd(i,'rappel',e.target.value)} /></div>
          <div><label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Lot n°</label><input className="adm-input" value={row.lot||''} onChange={e=>upd(i,'lot',e.target.value)} placeholder="Numéro de lot" /></div>
          <button type="button" className="adm-ta-btn adm-ta-del" style={{ marginTop:16 }} onClick={()=>del(i)}>🗑</button>
        </div>
      ))}
      <button type="button" className="adm-btn adm-btn-ghost" style={{ alignSelf:'flex-start', fontSize:12 }} onClick={()=>setRows(r=>[...r,{type:'',date:'',rappel:'',lot:''}])}>+ Ajouter une vaccination</button>
    </div>
  )
}

// ── Lignes antiparasitaires dynamiques ───────────────────────
function AntiparaRows({ rows, setRows }) {
  const upd = (i,k,v) => setRows(r=>r.map((x,j)=>j===i?{...x,[k]:v}:x))
  const del = (i) => { if(rows.length>1)setRows(r=>r.filter((_,j)=>j!==i)) }
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
      {rows.map((row,i)=>(
        <div key={i} style={{ display:'grid', gridTemplateColumns:'1.5fr 1.5fr 2fr 1.5fr auto', gap:'6px 8px', alignItems:'end', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:8, padding:'10px 12px' }}>
          <div>
            <label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Type</label>
            <select className="adm-input" value={row.type||'Vermifuge'} onChange={e=>upd(i,'type',e.target.value)}>
              {['Vermifuge','Anti-puces','Anti-tiques','Multiples'].map(o=><option key={o} value={o}>{o}</option>)}
            </select>
          </div>
          <div><label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Date</label><input className="adm-input" type="date" value={row.date||''} onChange={e=>upd(i,'date',e.target.value)} /></div>
          <div><label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Produit</label><input className="adm-input" value={row.produit||''} onChange={e=>upd(i,'produit',e.target.value)} placeholder="Ex: Frontline" /></div>
          <div><label style={{ fontSize:10, fontWeight:700, color:'var(--slate)', textTransform:'uppercase' }}>Prochaine date</label><input className="adm-input" type="date" value={row.prochaine_date||''} onChange={e=>upd(i,'prochaine_date',e.target.value)} /></div>
          <button type="button" className="adm-ta-btn adm-ta-del" style={{ marginTop:16 }} onClick={()=>del(i)}>🗑</button>
        </div>
      ))}
      <button type="button" className="adm-btn adm-btn-ghost" style={{ alignSelf:'flex-start', fontSize:12 }} onClick={()=>setRows(r=>[...r,{type:'Vermifuge',date:'',produit:'',prochaine_date:''}])}>+ Ajouter un traitement</button>
    </div>
  )
}

// ── Helpers layout (hors composants = stables) ───────────────
const SEC = ({ title }) => (
  <div style={{ gridColumn:'1/-1', fontSize:11, fontWeight:700, color:'var(--gold-dk)', textTransform:'uppercase', letterSpacing:'0.08em', borderBottom:'2px solid var(--gold)', paddingBottom:4, marginTop:10, marginBottom:2 }}>{title}</div>
)
const Field = ({ label, full, children }) => {
  const raw = label || ''
  const idx = raw.indexOf('*')
  const before = idx >= 0 ? raw.slice(0, idx) : raw
  const after  = idx >= 0 ? raw.slice(idx + 1) : ''
  const hasAst = idx >= 0
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:4, gridColumn:full?'1/-1':undefined }}>
      <label style={{ fontSize:11, fontWeight:700, color:'var(--slate)', textTransform:'uppercase', letterSpacing:'0.06em' }}>
        {before}{hasAst && <span style={{ color:'#dc2626', fontWeight:800 }}>*</span>}{after}
      </label>
      {children}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════
// 1. CARNET DE SANTÉ
// ══════════════════════════════════════════════════════════════
export function CarnetSanteForm({ show, onClose, onGenerate, users }) {
  const sigRef = useRef(null)
  const [sig, setSig]       = useState(null)
  const [photo, setPhoto]   = useState(null)
  const [cachet, setCachet] = useState(null)
  const [userResolved, setUserResolved] = useState(null)
  const [vaccins, setVaccins]     = useState([{ type:'', date:'', rappel:'', lot:'' }])
  const [antiparas, setAntiparas] = useState([{ type:'Vermifuge', date:'', produit:'', prochaine_date:'' }])
  const [d, setD] = useState({
    name:'', species:'', breed:'', age:'', sex:'Male', sterilise:'Non', poids:'',
    attestation_date: new Date().toISOString().split('T')[0],
    attestation_veterinaire:'', attestation_ordre:'', attestation_validite:'1 an', attestation_observations:'',
    proprietaire_nom:'', proprietaire_tel:'', proprietaire_email:'',
    proprietaire_adresse:'', proprietaire_ville:'', proprietaire_cp:'',
    veterinaire_cabinet:'', veterinaire_tel:'', veterinaire_adresse:'', veterinaire_email:'',
  })
  if (!show) return null
  const upd = (k) => (e) => setD(p=>({...p,[k]:e.target.value}))

  return (
    <div className="adm-card" style={{ maxWidth:750 }}>
      <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:17, fontWeight:800, color:'var(--blue)', marginBottom:20 }}>📋 Carnet de santé animal</h3>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px 20px' }}>

        <SEC title="👤 Utilisateur destinataire" />
        <UserSearch users={users||[]} resolved={userResolved} setResolved={setUserResolved} />

        <SEC title="🐾 Identité de l'animal" />
        <Field label="Nom *"><input className="adm-input" value={d.name} onChange={upd('name')} placeholder="Ex: Rex" /></Field>
        <Field label="Espèce *"><input className="adm-input" value={d.species} onChange={upd('species')} placeholder="Ex: Chien" required /></Field>
        <Field label="Race"><input className="adm-input" value={d.breed} onChange={upd('breed')} placeholder="Ex: Labrador" /></Field>
        <Field label="Âge"><input className="adm-input" type="number" min="0" value={d.age} onChange={upd('age')} placeholder="Ex: 2" /></Field>
        <Field label="Sexe">
          <select className="adm-input" value={d.sex} onChange={upd('sex')}>
            <option value="Male">Mâle</option><option value="Femelle">Femelle</option>
          </select>
        </Field>
        <Field label="Stérilisé(e)">
          <select className="adm-input" value={d.sterilise} onChange={upd('sterilise')}>
            <option value="Non">Non</option><option value="Oui">Oui</option>
          </select>
        </Field>
        <Field label="Poids (kg)"><input className="adm-input" type="number" value={d.poids} onChange={upd('poids')} placeholder="Ex: 15.5" /></Field>
        <div style={{ gridColumn:'1/-1' }}><ImgUpload label="Photo de l'animal" hint="JPG, PNG — max 5 Mo" preview={photo} onFile={setPhoto} /></div>

        <SEC title="💉 Carnet de vaccinations" />
        <div style={{ gridColumn:'1/-1' }}><VaccinRows rows={vaccins} setRows={setVaccins} /></div>

        <SEC title="🐛 Traitements antiparasitaires" />
        <div style={{ gridColumn:'1/-1' }}><AntiparaRows rows={antiparas} setRows={setAntiparas} /></div>

        <SEC title="🩺 Attestation vétérinaire" />
        <Field label="Date de l'examen *"><input className="adm-input" type="date" value={d.attestation_date} onChange={upd('attestation_date')} /></Field>
        <Field label="Nom du vétérinaire *"><input className="adm-input" value={d.attestation_veterinaire} onChange={upd('attestation_veterinaire')} placeholder="Dr. Dupont" /></Field>
        <Field label="Numéro d'Ordre"><input className="adm-input" value={d.attestation_ordre} onChange={upd('attestation_ordre')} placeholder="N° d'inscription à l'Ordre" /></Field>
        <Field label="Validité *">
          <select className="adm-input" value={d.attestation_validite} onChange={upd('attestation_validite')}>
            {['1 mois','3 mois','6 mois','1 an','Permanent'].map(o=><option key={o} value={o}>{o}</option>)}
          </select>
        </Field>
        <Field full label="Observations médicales"><textarea className="adm-input" rows={3} style={{ resize:'vertical' }} value={d.attestation_observations} onChange={upd('attestation_observations')} placeholder="État général, recommandations…" /></Field>
        <div style={{ gridColumn:'1/-1', display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
          <ImgUpload label="Cachet vétérinaire" hint="PNG fond transparent recommandé" preview={cachet} onFile={setCachet} circle />
          <SigCanvas canvasRef={sigRef} label="Signature vétérinaire" onSign={setSig} />
        </div>

        <SEC title="👤 Propriétaire" />
        <Field label="Nom du propriétaire *"><input className="adm-input" value={d.proprietaire_nom} onChange={upd('proprietaire_nom')} placeholder="Jean Martin" /></Field>
        <Field label="Téléphone"><input className="adm-input" type="tel" value={d.proprietaire_tel} onChange={upd('proprietaire_tel')} placeholder="06 12 34 56 78" /></Field>
        <Field label="Email"><input className="adm-input" type="email" value={d.proprietaire_email} onChange={upd('proprietaire_email')} placeholder="jean.martin@email.com" /></Field>
        <Field label="Adresse"><input className="adm-input" value={d.proprietaire_adresse} onChange={upd('proprietaire_adresse')} placeholder="123 rue de la Paix" /></Field>
        <Field label="Ville"><input className="adm-input" value={d.proprietaire_ville} onChange={upd('proprietaire_ville')} placeholder="Paris" /></Field>
        <Field label="Code postal"><input className="adm-input" value={d.proprietaire_cp} onChange={upd('proprietaire_cp')} placeholder="75000" /></Field>

        <SEC title="🏥 Cabinet vétérinaire" />
        <Field label="Nom du cabinet"><input className="adm-input" value={d.veterinaire_cabinet} onChange={upd('veterinaire_cabinet')} placeholder="Clinique Vétérinaire du Parc" /></Field>
        <Field label="Téléphone"><input className="adm-input" type="tel" value={d.veterinaire_tel} onChange={upd('veterinaire_tel')} placeholder="01 23 45 67 89" /></Field>
        <Field label="Adresse"><input className="adm-input" value={d.veterinaire_adresse} onChange={upd('veterinaire_adresse')} placeholder="456 avenue des Champs" /></Field>
        <Field label="Email"><input className="adm-input" type="email" value={d.veterinaire_email} onChange={upd('veterinaire_email')} placeholder="contact@veto-parc.fr" /></Field>

      </div>
      <div style={{ display:'flex', gap:10, marginTop:24 }}>
        <button className="adm-btn adm-btn-primary" onClick={()=>onGenerate(d,vaccins,antiparas,sig,photo,cachet,userResolved)}>📄 Générer le carnet complet</button>
        <button className="adm-btn adm-btn-ghost" onClick={onClose}>Annuler</button>
      </div>
    </div>
  )
}

// ══════════════════════════════════════════════════════════════
// 2. ATTESTATION VÉTÉRINAIRE
// ══════════════════════════════════════════════════════════════
export function AttestationVetForm({ show, onClose, onGenerate, users }) {
  const sigRef = useRef(null)
  const [sig, setSig]     = useState(null)
  const [stamp, setStamp] = useState(null)
  const [userResolved, setUserResolved] = useState(null)
  const [d, setD] = useState({
    vetNom:'', vetNumOrdre:'', vetAdresse:'', vetTel:'', vetEmail:'',
    animalNom:'', animalEspece:'', animalRace:'', animalSexe:'', animalCouleur:'',
    animalPuce:'', proprietaireNom:'', animalId:'',
    attBonSante:true, attVaccination:true, attMaladie:true, attTransport:true,
    ville:'', date: new Date().toISOString().split('T')[0],
  })
  if (!show) return null
  const upd  = (k) => (e) => setD(p=>({...p,[k]:e.target.value}))
  const updCb = (k) => (e) => setD(p=>({...p,[k]:e.target.checked}))

  return (
    <div className="adm-card" style={{ maxWidth:700 }}>
      <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:17, fontWeight:800, color:'var(--blue)', marginBottom:20 }}>🩺 Attestation vétérinaire</h3>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px 20px' }}>

        <SEC title="Utilisateur destinataire" />
        <UserSearch users={users||[]} resolved={userResolved} setResolved={setUserResolved} />

        <SEC title="Informations du vétérinaire" />
        <Field label="Nom et prénom du vétérinaire *"><input className="adm-input" value={d.vetNom} onChange={upd('vetNom')} /></Field>
        <Field label="Numéro d'inscription à l'Ordre *"><input className="adm-input" value={d.vetNumOrdre} onChange={upd('vetNumOrdre')} /></Field>
        <Field full label="Adresse du cabinet *"><input className="adm-input" value={d.vetAdresse} onChange={upd('vetAdresse')} /></Field>
        <Field label="Téléphone *"><input className="adm-input" type="tel" value={d.vetTel} onChange={upd('vetTel')} placeholder="01 23 45 67 89" /></Field>
        <Field label="Email *"><input className="adm-input" type="email" value={d.vetEmail} onChange={upd('vetEmail')} placeholder="contact@cabinet.fr" /></Field>

        <SEC title="Informations de l'animal" />
        <Field label="Nom de l'animal *"><input className="adm-input" value={d.animalNom} onChange={upd('animalNom')} /></Field>
        <Field label="Espèce *">
          <select className="adm-input" value={d.animalEspece} onChange={upd('animalEspece')}>
            <option value="">Sélectionner</option>
            <option value="Chien">Chien</option><option value="Chat">Chat</option><option value="Autre">Autre</option>
          </select>
        </Field>
        <Field label="Race"><input className="adm-input" value={d.animalRace} onChange={upd('animalRace')} /></Field>
        <Field label="Sexe *">
          <select className="adm-input" value={d.animalSexe} onChange={upd('animalSexe')}>
            <option value="">Sélectionner</option>
            <option value="Mâle">Mâle</option><option value="Femelle">Femelle</option>
          </select>
        </Field>
        <Field label="Couleur"><input className="adm-input" value={d.animalCouleur} onChange={upd('animalCouleur')} /></Field>
        <Field label="Pucé *">
          <select className="adm-input" value={d.animalPuce} onChange={upd('animalPuce')}>
            <option value="">Sélectionner</option>
            <option value="Oui">Oui</option><option value="Non">Non</option>
          </select>
        </Field>
        <Field label="Propriétaire de l'animal *"><input className="adm-input" value={d.proprietaireNom} onChange={upd('proprietaireNom')} /></Field>
        <Field label="Identification (puce/tatouage) *"><input className="adm-input" value={d.animalId} onChange={upd('animalId')} /></Field>

        <SEC title="Attestations — après examen clinique, j\'atteste que l\'animal est :" />
        {[['attBonSante','En bonne santé générale'],['attVaccination','À jour de ses vaccinations obligatoires'],['attMaladie',"Ne présente aucun signe de maladie contagieuse au moment de l'examen"],['attTransport','Apte au transport auquel il est destiné']].map(([k,label])=>(
          <div key={k} style={{ display:'flex', alignItems:'center', gap:8, gridColumn:'1/-1' }}>
            <input type="checkbox" checked={!!d[k]} onChange={updCb(k)} style={{ width:16, height:16, accentColor:'var(--gold)' }} />
            <label style={{ fontSize:13, color:'var(--blue)' }}>{label}</label>
          </div>
        ))}

        <SEC title="Lieu et date" />
        <Field label="Ville où est établie l'attestation *"><input className="adm-input" value={d.ville} onChange={upd('ville')} /></Field>
        <Field label="Date de l'attestation *"><input className="adm-input" type="date" value={d.date} onChange={upd('date')} /></Field>

        <SEC title="Cachet et signature" />
        <div style={{ gridColumn:'1/-1', display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
          <ImgUpload label="Cachet du cabinet" hint="PNG fond transparent — 200×200px recommandé" preview={stamp} onFile={setStamp} circle />
          <SigCanvas canvasRef={sigRef} label="Signature numérique du vétérinaire" onSign={setSig} />
        </div>

      </div>
      <div style={{ display:'flex', gap:10, marginTop:20 }}>
        <button className="adm-btn adm-btn-primary" onClick={()=>onGenerate(d,sig,stamp,userResolved)}>📄 Générer PDF</button>
        <button className="adm-btn adm-btn-ghost" onClick={onClose}>Annuler</button>
      </div>
    </div>
  )
}

// ══════════════════════════════════════════════════════════════
// 3. DOCUMENT D'IDENTIFICATION
// ══════════════════════════════════════════════════════════════
export function IdentificationForm({ show, onClose, onGenerate, users }) {
  const [userResolved, setUserResolved] = useState(null)
  const [d, setD] = useState({
    ownerName:'', ownerAddress:'', phone1:'', phone2:'', email:'',
    veterinaireNom:'', veterinaireContact:'',
    animalName:'', animalEspece:'CHAT', birthDate:'', breed:'', coat:'',
    hairType:'COURT', sex:'MALE', sterilise:'NON', paysOrigine:'FRANCE',
  })
  if (!show) return null
  const upd = (k) => (e) => setD(p=>({...p,[k]:e.target.value}))

  return (
    <div className="adm-card" style={{ maxWidth:700 }}>
      <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:17, fontWeight:800, color:'var(--blue)', marginBottom:20 }}>🪪 Document d'identification animale</h3>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px 20px' }}>

        <SEC title="Utilisateur destinataire" />
        <UserSearch users={users||[]} resolved={userResolved} setResolved={setUserResolved} />

        <SEC title="Propriétaire" />
        <Field full label="Nom et prénom du propriétaire *"><input className="adm-input" value={d.ownerName} onChange={upd('ownerName')} placeholder="Ex: Dupont Jean" /></Field>
        <Field full label="Adresse complète du propriétaire *"><input className="adm-input" value={d.ownerAddress} onChange={upd('ownerAddress')} placeholder="Ex: 123 Rue de Paris, 75001 Paris" /></Field>
        <Field label="Téléphone 1 *"><input className="adm-input" type="tel" value={d.phone1} onChange={upd('phone1')} placeholder="Ex: 0123456789" /></Field>
        <Field label="Téléphone 2 (optionnel)"><input className="adm-input" type="tel" value={d.phone2} onChange={upd('phone2')} placeholder="Ex: 0612345678" /></Field>
        <Field full label="Adresse e-mail *"><input className="adm-input" type="email" value={d.email} onChange={upd('email')} placeholder="Ex: exemple@email.fr" /></Field>

        <SEC title="Vétérinaire traitant" />
        <Field label="Nom du vétérinaire traitant *"><input className="adm-input" value={d.veterinaireNom} onChange={upd('veterinaireNom')} placeholder="Ex: Dr. Martin" /></Field>
        <Field label="Contact du vétérinaire"><input className="adm-input" value={d.veterinaireContact} onChange={upd('veterinaireContact')} placeholder="Ex: 01 23 45 67 89" /></Field>

        <SEC title="Description de l'animal" />
        <Field full label="Nom de l'animal *"><input className="adm-input" value={d.animalName} onChange={upd('animalName')} placeholder="Ex: Félix" /></Field>
        <Field label="Espèce *">
          <select className="adm-input" value={d.animalEspece} onChange={upd('animalEspece')}>
            <option value="CHAT">Chat</option><option value="CHIEN">Chien</option><option value="AUTRE">Autre</option>
          </select>
        </Field>
        <Field label="Date de naissance *"><input className="adm-input" type="date" value={d.birthDate} onChange={upd('birthDate')} /></Field>
        <Field label="Race *"><input className="adm-input" value={d.breed} onChange={upd('breed')} placeholder="Ex: Européen" /></Field>
        <Field label="Couleur *"><input className="adm-input" value={d.coat} onChange={upd('coat')} placeholder="Ex: Noir et blanc" /></Field>
        <Field label="Type de poil *">
          <select className="adm-input" value={d.hairType} onChange={upd('hairType')}>
            <option value="COURT">Court</option><option value="LONG">Long</option><option value="MI-LONG">Mi-long</option>
          </select>
        </Field>
        <Field label="Sexe *">
          <select className="adm-input" value={d.sex} onChange={upd('sex')}>
            <option value="MALE">Mâle</option><option value="FEMALE">Femelle</option>
          </select>
        </Field>
        <Field label="Stérilisé *">
          <select className="adm-input" value={d.sterilise} onChange={upd('sterilise')}>
            <option value="NON">Non</option><option value="OUI">Oui</option>
          </select>
        </Field>
        <Field label="Pays d'origine *"><input className="adm-input" value={d.paysOrigine} onChange={upd('paysOrigine')} placeholder="Ex: FRANCE" /></Field>

      </div>
      <div style={{ display:'flex', gap:10, marginTop:20 }}>
        <button className="adm-btn adm-btn-primary" onClick={()=>onGenerate(d,userResolved)}>📄 Générer PDF</button>
        <button className="adm-btn adm-btn-ghost" onClick={onClose}>Annuler</button>
      </div>
    </div>
  )
}

// ══════════════════════════════════════════════════════════════
// 4. ATTESTATION DE CESSION — même logique que livraison (double signature)
// ══════════════════════════════════════════════════════════════
export function CessionForm({ show, onClose, onGenerate, users }) {
  const sigRef = useRef(null)
  const [sig, setSig]               = useState(null)
  const [userResolved, setUserResolved] = useState(null)
  const [d, setD] = useState({
    // Cédant
    cedantNom:'', cedantAdresse:'', cedantTel:'', cedantEmail:'', cedantSiret:'',
    // Acquéreur
    acquereurNom:'', acquereurAdresse:'', acquereurTel:'', acquereurEmail:'', acquereurPieceId:'',
    // Animal
    animalNom:'', animalEspece:'', animalRace:'', animalDateNaissance:'',
    animalSexe:'Mâle', animalId:'',
    // Cession
    prix:'', date: new Date().toISOString().split('T')[0],
    // Documents transférés
    documents:[{ document:'', reference:'', nombre:'1', date:new Date().toISOString().split('T')[0] }],
  })

  if (!show) return null
  const upd = (k) => (e) => setD(p => ({ ...p, [k]: e.target.value }))
  const updDoc = (i, k) => (e) => setD(p => {
    const docs = p.documents.map((r,idx) => idx===i ? {...r,[k]:e.target.value} : r)
    return {...p, documents:docs}
  })
  const addDoc = () => setD(p => ({...p, documents:[...p.documents, {document:'', reference:'', nombre:'1', date:new Date().toISOString().split('T')[0]}]}))
  const removeDoc = (i) => setD(p => ({...p, documents:p.documents.filter((_,idx)=>idx!==i)}))

  const rowStyle = { display:'grid', gridTemplateColumns:'2fr 1fr 60px 120px 32px', gap:6, alignItems:'center', marginBottom:6 }

  return (
    <div className="adm-card" style={{ maxWidth:750 }}>
      <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:17, fontWeight:800, color:'var(--blue)', marginBottom:20 }}>📜 Attestation de cession</h3>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px 20px' }}>

        <SEC title="Utilisateur destinataire (acquéreur)" />
        <UserSearch users={users||[]} resolved={userResolved} setResolved={u => {
          setUserResolved(u)
          if (u) setD(p => ({ ...p, acquereurNom: u.name, acquereurEmail: u.email }))
        }} />

        <SEC title="Cédant (vendeur)" />
        <Field label="Nom / Raison sociale *"><input className="adm-input" value={d.cedantNom} onChange={upd('cedantNom')} placeholder="Animaux pour Adoption de la France" /></Field>
        <Field label="Adresse *"><input className="adm-input" value={d.cedantAdresse} onChange={upd('cedantAdresse')} placeholder="123 Rue des Compagnons, 75001 Paris" /></Field>
        <Field label="Téléphone"><input className="adm-input" type="tel" value={d.cedantTel} onChange={upd('cedantTel')} /></Field>
        <Field label="Email"><input className="adm-input" type="email" value={d.cedantEmail} onChange={upd('cedantEmail')} /></Field>
        <Field label="N° SIRET"><input className="adm-input" value={d.cedantSiret} onChange={upd('cedantSiret')} /></Field>

        <SEC title="Acquéreur (client)" />
        <Field label="Nom et prénom *"><input className="adm-input" value={d.acquereurNom} onChange={upd('acquereurNom')} /></Field>
        <Field label="Adresse *"><input className="adm-input" value={d.acquereurAdresse} onChange={upd('acquereurAdresse')} /></Field>
        <Field label="Téléphone"><input className="adm-input" type="tel" value={d.acquereurTel} onChange={upd('acquereurTel')} /></Field>
        <Field label="Email *"><input className="adm-input" type="email" value={d.acquereurEmail} onChange={upd('acquereurEmail')} /></Field>
        <Field label="Pièce d'identité"><input className="adm-input" value={d.acquereurPieceId} onChange={upd('acquereurPieceId')} placeholder="CNI n° ou Passeport n°" /></Field>

        <SEC title="Animal cédé" />
        <Field label="Nom de l'animal *"><input className="adm-input" value={d.animalNom} onChange={upd('animalNom')} /></Field>
        <Field label="Espèce *"><input className="adm-input" value={d.animalEspece} onChange={upd('animalEspece')} placeholder="Chien, Chat…" /></Field>
        <Field label="Race *"><input className="adm-input" value={d.animalRace} onChange={upd('animalRace')} /></Field>
        <Field label="Date de naissance"><input className="adm-input" type="date" value={d.animalDateNaissance} onChange={upd('animalDateNaissance')} /></Field>
        <Field label="Sexe *">
          <select className="adm-input" value={d.animalSexe} onChange={upd('animalSexe')}>
            <option value="Mâle">Mâle</option><option value="Femelle">Femelle</option>
          </select>
        </Field>
        <Field label="N° identification (puce/tatouage) *"><input className="adm-input" value={d.animalId} onChange={upd('animalId')} placeholder="Ex: 250269612345678" /></Field>

        <SEC title="Conditions de cession" />
        <Field label="Prix de cession (€)"><input className="adm-input" type="number" min="0" step="0.01" value={d.prix} onChange={upd('prix')} placeholder="0.00" /></Field>
        <Field label="Date de cession *"><input className="adm-input" type="date" value={d.date} onChange={upd('date')} /></Field>

      </div>

      {/* Documents transférés — pleine largeur */}
      <div style={{ marginTop:18 }}>
        <div style={{ fontWeight:700, fontSize:12, color:'var(--blue)', textTransform:'uppercase', letterSpacing:'.5px', marginBottom:10, paddingBottom:6, borderBottom:'2px solid var(--blue-lt)' }}>
          Documents transférés
        </div>
        {/* En-têtes colonnes */}
        <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 60px 130px 32px', gap:6, marginBottom:4 }}>
          {['Document','Référence','Nombre','Date',''].map((h,i) => (
            <span key={i} style={{ fontSize:10, fontWeight:600, color:'var(--blue)', textTransform:'uppercase', letterSpacing:'.3px' }}>{h}</span>
          ))}
        </div>
        {d.documents.map((row, i) => (
          <div key={i} style={rowStyle}>
            <input className="adm-input" placeholder="Ex: Carnet de santé" value={row.document} onChange={updDoc(i,'document')} />
            <input className="adm-input" placeholder="Réf." value={row.reference} onChange={updDoc(i,'reference')} />
            <input className="adm-input" type="number" min="1" value={row.nombre} onChange={updDoc(i,'nombre')} style={{ textAlign:'center' }} />
            <input className="adm-input" type="date" value={row.date} onChange={updDoc(i,'date')} />
            <button onClick={() => removeDoc(i)} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--red)', fontSize:16, padding:'0 4px' }} title="Supprimer">✕</button>
          </div>
        ))}
        <button className="adm-btn adm-btn-ghost" style={{ marginTop:6, fontSize:12 }} onClick={addDoc}>+ Ajouter un document</button>
      </div>

      <div style={{ marginTop:18 }}>
        <div style={{ fontWeight:700, fontSize:12, color:'var(--blue)', textTransform:'uppercase', letterSpacing:'.5px', marginBottom:10, paddingBottom:6, borderBottom:'2px solid var(--blue-lt)' }}>
          Signature du cédant (admin)
        </div>
        <SigCanvas canvasRef={sigRef} label="Votre signature (admin / cédant)" onSign={setSig} />
      </div>

      {!sig && (
        <div style={{ marginTop:14, padding:'10px 14px', background:'#FEF9C3', border:'1.5px solid #FCD34D', borderRadius:8, fontSize:12, color:'#92400E', fontWeight:600 }}>
          ⚠️ La signature admin est obligatoire pour envoyer l&apos;attestation au client.
        </div>
      )}
      <div style={{ display:'flex', gap:10, marginTop:16 }}>
        <button className="adm-btn adm-btn-primary" disabled={!sig || !userResolved} style={{opacity:(!sig||!userResolved)?.5:1}} onClick={() => onGenerate(d, sig, userResolved)}>
          📤 Signer & Envoyer au client pour co-signature
        </button>
        <button className="adm-btn adm-btn-ghost" onClick={onClose}>Annuler</button>
      </div>
    </div>
  )
}